export const GOTHAM = 'Gotham'
export const GOTHAM_MEDIUM = 'Gotham-Medium'
export const GOTHAM_BOLD = 'Gotham-Bold'
export const NOTOSANS = 'NotoSans-Regular'
export const NOTOSANS_MEDIUM = 'NotoSans'

export const HEADER_SIZE = '20px'
export const TITLE_SIZE = '16px'
export const NORMAL_SIZE = '14px'
export const SMALL_SIZE = '12px'



// WEBPACK FOOTER //
// ./src/constants/fonts.js